import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC8QxZdK7MyJS9t8BfuQikQmcUjR2GCN8Y",
  authDomain: "couponlagaobackend.firebaseapp.com",
  projectId: "couponlagaobackend",
  storageBucket: "couponlagaobackend.firebasestorage.app",
  messagingSenderId: "834329306980",
  appId: "1:834329306980:web:03fe849e51c68fa05ffc71",
  measurementId: "G-T2H0B78GEL",
};

const app = initializeApp(firebaseConfig);

// ✅ Firebase Auth
export const auth = getAuth(app);

// ✅ Firestore Database (THIS WAS MISSING)
export const db = getFirestore(app);
